// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__Di4p7","rtParagraph":"rich-text-renderer_rtParagraph__So8l2"};